import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams, useLocation } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import { groups } from "./ReportList";

const Reports = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const { search } = useLocation();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  // URL param: ?classfield=activity | financial | sustainability ...
  const params = new URLSearchParams(search);
  const categoryParam = (params.get("classfield") || "").toLowerCase().trim();

  // 1) classfield filtresi
  const filteredGroups = groups
    .map((g) => ({
      ...g,
      items: categoryParam
        ? g.items.filter((it) => (it.classfield || "").toLowerCase() === categoryParam)
        : g.items,
    }))
    .filter((g) => (g.items?.length || 0) > 0);

  // 2) yıl bazlı grupla (period içinde 4 haneli yıl arar)
  const groupsByYear = filteredGroups.reduce((acc, g) => {
    const periodStr = (g.period?.en || g.period?.tr || "").toString();
    const yearMatch = periodStr.match(/\b(19|20)\d{2}\b/);
    const year = yearMatch ? Number(yearMatch[0]) : null;
    if (!year) return acc;
    if (!acc[year]) acc[year] = [];
    acc[year].push(g);
    return acc;
  }, /** @type {Record<number, typeof groups>} */({}));

  const sortedYears = Object.keys(groupsByYear).map(Number).sort((a, b) => b - a);

  return (
    <div>
      <Meta title={t("reports")} description={t("reports")} lang={lang} />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("reports")}
              </h1>
            </div>
          </div>
        </div>

        <div className="po-container">
          <InvestorSidebar />

          <main className="pol-content">
            <section className="pol-card">
              <ul className="pol-list">
                {sortedYears.length === 0 && (
                  <li>{L === "tr" ? "Kayıt bulunamadı." : "No records found."}</li>
                )}

                {sortedYears.map((year, yi) => (
                  <li key={year} className="fr-year-block">
                    {/* en güncel yılı açık başlat */}
                    <details className="fr-year-details" {...(yi === 0 ? { open: true } : {})}>
                      <summary className="fr-year fr-summary">{year}</summary>

                      {/* Yıl içindeki kategoriler */}
                      {groupsByYear[year].map((g, gi) => (
                        <section key={gi}>
                          {/* <h3 style={{ margin: "12px 0 8px" }}>
                            {g.category?.[L] || g.category?.en}
                          </h3> */}

                          {g.items.map((it, ii) => (
                            <div key={`${gi}-${ii}`} className="pol-row">
                              <span className="pol-title">{it.title?.[L] || it.title?.en}</span>
                              <a
                                href={it.href?.[L] || it.href?.en}
                                target="_blank"
                                rel="noreferrer"
                                className="pol-dl"
                                aria-label={(t("download") || (L === "tr" ? "İndir" : "Download")) + ": " + (it.title?.[L] || it.title?.en)}
                              >
                                <LuDownload size={18} />
                              </a>
                            </div>
                          ))}
                        </section>
                      ))}
                    </details>
                  </li>
                ))}
              </ul>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Reports;
